import * as React from "react";
import { useModalStore } from "../../store/useModalStore";
import { useMutation } from "@tanstack/react-query";
import { postEmail } from "../../lib/apis/v1/auth.service";
import FailSnackbar from "../ui/snackbar/fail.component";
import { MODAL_KEY } from "../../lib/constants/modal.constants";
import ConfirmModal from "./confirm.modal";
import { TextField } from "@mui/material";
import type { ModalComponentProps } from "../../types/modal.types";


interface EmailProps {
  receiver: string;
  subject: string;
  body: string;
}

export default function InquiryCreateModal({ id, onClose }: ModalComponentProps) {

  const [form, setForm] = React.useState<EmailProps>({
    receiver: "",
    subject: "로그인 관련 문의",
    body: "",
  });
  const [emailHelper, setEmailHelper] = React.useState("");
  const [emailError, setEmailError] = React.useState(false);

  const { openModal } = useModalStore();

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const validateEmail = (value: string) => {
    if (value === "") {
      setEmailError(false);
      setEmailHelper("");
    } else if (!emailRegex.test(value)) {
      setEmailError(true);
      setEmailHelper("이메일 형식을 맞춰주세요. (ex. abcd@abcd.com)");
    } else {
      setEmailError(false);
      setEmailHelper("");
    }
  };

  const changeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target;
    setForm((state) => ({ ...state, [id]: value }));
  };

  const emailMutation = useMutation({
    mutationFn: (form: EmailProps) => postEmail(form),
    onSuccess: (res) => {
      const { error } = res || {}
      if (error) {
        FailSnackbar("");
      } else {
        onClose?.();
        openModal(MODAL_KEY.Alert, { title: "로그인 문의 완료", content: `로그인 문의가 완료되었습니다. 처리 여부에 따라 작성해주신 메일로 답변드립니다.\n 감사합니다.` })
      }
    }
  })

  return (
    <ConfirmModal
      id={id}
      onClose={onClose}
      title="문의하기"
      rightButton={{
        title: "문의하기", disabled: !emailRegex.test(form.receiver), onClick: () => {
          emailMutation.mutate(form);
        }
      }}>
      <div className="flex flex-col gap-4">

        <TextField
          id="receiver"
          className="w-[552px] h-[56px]"
          label="이메일*"
          type="email"
          error={emailError}
          helperText={emailHelper}
          inputMode="numeric"
          value={form.receiver}
          slotProps={{ inputLabel: { shrink: true } }}
          onChange={(e) => {
            changeHandler(e as React.ChangeEvent<HTMLInputElement>);
            validateEmail(e.target.value);
          }}
        />
        <TextField
          multiline
          maxRows={9}
          id="body"
          className="w-[552px]"
          size="medium"
          label="문의 내용"
          value={form.body}
          onChange={changeHandler}
          slotProps={{
            inputLabel: { shrink: true },
            input: {
              sx: {
                height: 200,
                alignItems: "flex-start",
              },
            },
          }}
        />
      </div>
    </ConfirmModal>
  );
};
